import type { Action } from 'redux';
import NotificationActions from '../../../../main/actions/NotificationActions';
import dash_api from '../../../../main/support/dash_api';
import { ReduxAsyncAction } from '../../../services/ReduxAsyncAction';
import type { GetPostbacksConversionValueMappingResponseActionPayload } from '../SKANPostbacksConversionMapping.types';

const GetPostbacksConversionValueMapping = new ReduxAsyncAction<
  'GET_POSTBACKS_CONVERSION_VALUE_MAPPING',
  void,
  GetPostbacksConversionValueMappingResponseActionPayload
>('GET_POSTBACKS_CONVERSION_VALUE_MAPPING');

GetPostbacksConversionValueMapping.registerRequest(async () => {
  try {
    const response = await dash_api.get<GetPostbacksConversionValueMappingResponseActionPayload>(
      '/v1/skadnetworkv2/conversion-value-mapping'
    );

    return response.data;
  } catch (error) {
    NotificationActions.showNotification('Cannot get Conversion Value Mapping. Please try again.', 'error');

    throw error;
  }
});

export const GET_POSTBACKS_CONVERSION_VALUE_MAPPING = GetPostbacksConversionValueMapping.actionNamespaceConstants;

export const getPostbacksConversionValueMapping = GetPostbacksConversionValueMapping.request;

export type GetPostbacksConversionValueMappingResponseAction = Action<
  typeof GET_POSTBACKS_CONVERSION_VALUE_MAPPING.response
> & { data: GetPostbacksConversionValueMappingResponseActionPayload };
